import React from 'react';
import ProductCard from './ProductCard';

const ProductList = ({ products }) => {
  const safeProducts = Array.isArray(products) ? products : [];

  if (safeProducts.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-20 h-20 rounded-full bg-gray-50 flex items-center justify-center mb-5">
          <span className="text-3xl">📦</span>
        </div>
        <p className="text-gray-700 text-sm font-medium mb-1">No products found</p>
        <p className="text-gray-400 text-xs">Try a different search term or category.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {safeProducts.map((product) => (
        <ProductCard key={product._id} product={product} />
      ))}
    </div>
  );
};

export default ProductList;